var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 2H7.875C6.83984 2 6 2.83984 6 3.875V20.125C6 21.1602 6.83984 22 7.875 22H16.625C17.6602 22 18.5 21.1602 18.5 20.125V3.875C18.5 2.83984 17.6602 2 16.625 2ZM12.25 20.75C11.5586 20.75 11 20.1914 11 19.5C11 18.8086 11.5586 18.25 12.25 18.25C12.9414 18.25 13.5 18.8086 13.5 19.5C13.5 20.1914 12.9414 20.75 12.25 20.75ZM16.625 16.5313C16.625 16.7891 16.4141 17 16.1563 17H8.34375C8.08594 17 7.875 16.7891 7.875 16.5313V4.34375C7.875 4.08594 8.08594 3.875 8.34375 3.875H16.1563C16.4141 3.875 16.625 4.08594 16.625 4.34375V16.5313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.14c7d3e30867f769e1adace31741c56a.svg";
export { ForwardRef as ReactComponent };